export * from './a11y-tooltip.component';
export * from './a11y-tooltip.module';
